import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-oauth-success',
  imports: [],
  templateUrl: './oauth-success.component.html',
  styleUrl: './oauth-success.component.css'
})
export class OauthSuccessComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    const video = document.querySelector('.home-video') as HTMLVideoElement;
    if (video) {
      video.muted = true;
      setTimeout(() => {
        video.play().catch((err) => console.warn('Autoplay failed:', err));
      }, 50);
    }
  }
}
